import { render } from "./BrandAdriasonara.vue?vue&type=template&id=083d3c97"
import script from "./BrandAdriasonara.vue?vue&type=script&lang=ts"
export * from "./BrandAdriasonara.vue?vue&type=script&lang=ts"

import "./BrandAdriasonara.vue?vue&type=style&index=0&id=083d3c97&lang=scss"
script.render = render

export default script